/*
 *
 *  Cart
 *  contains basic js for the cart page
 *  !! Created by Charlotte on 29/08/2017
 *
 */
import '../../cart.js';

window.appLoaded.then(() => {
    $(document).ready(function () {
        /** CART.TPL **/
        // Submit button
        $('input.proceed').click(function () {
            document.location = strHrefCartLogin;
        });

        /** CART/CART-TABLE.TPL **/
        var blnCheckStock = false;
        if (WebsiteSettingBlnCheckStockAddCart && WebsiteSettingBlnUseStock) {
            blnCheckStock = true;
        }

        // Enter only numeric values in 'quantity' fields
        $('table.cart input[type="text"]').each(function () {
            $(this).numeric();
        });

        // When you go out of the field 'quantity' (input field) => update quantity in cart (session)
        $('.cart input[id^=qty]').blur(function () {
            CartUpdateCart($(this), blnCheckStock);
        });

        // When you enter in the field 'quantity' (input field) => update quantity in cart (session)
        $('.cart input[id^=qty]').keypress(function (e) {
            // Enter key
            if (e.keyCode == 13) {
                CartUpdateCart($(this), blnCheckStock);
                return false;
            }
        });

        // When you go out of the field 'quantity' (select box) => update quantity in cart (session)
        $('.cart select[id^=selQty]').change(function () {
            if ($(this).val() == 0) {
                // Click on 'more' (in quantity field) => show input field
                $(this).parent().find('.qty-text').removeClass('hidden');
                $(this).parent().find('.qty-select').addClass('hidden');
            } else {
                // Update quantity in cart (session)
                var objInput = $(this).parent().find('input[id^=qty]');
                objInput.val($(this).val());

                CartUpdateCart(objInput, blnCheckStock);
            }
        });

        // Remove the product from the cart
        $('a.delete, a.delete-mobile').click(function () {
            // Check if not clicked twice (or more) on the link
            if (!$(this).hasClass('busy')) {
                $(this).addClass('busy');
                var intCartKey = $(this).data('key');
                if (intCartKey > 0) {
                    RemoveFromCart(intCartKey);
                }
            }

            return false;
        });


        /** CART/DISCOUNTCODE.TPL **/
        // Show block 'Your discount code' after clicking on the link 'Fill in your discount code'
        $('a.show-discount-code').click(function () {
            // Hide link
            $('.discount-start').addClass('hidden');
            // Show discount code input field
            $('.discount-end').removeClass('hidden');
            // Focus on input field
            $('input#txtDiscountCode').focus();

            return false;
        });

        // Validate discount code
        AddDiscountCode();

        // Validate giftcard code
        // AddGiftCardCode();

        // Remove discount code
        RemoveDiscountCode();

        if (WebsiteSettingBlnUseGiftCards) {
            // Remove giftcard code
            RemoveGiftCardCode();
        }


        /** CART/DELIVERYCHOICE.TPL**/
        if (blnShowDeliveryOptionsInCart) {

            if (WebsiteSettingBlnCartPickUpProducts) {
                // Click on radio button 'Delivery on address' or 'Pick up'
                $('input[name=\'optDeliveryMainOption\'], input[name=\'optPickUpPoint\']').change(function () {

                    // Get selected radio buttons
                    var objDeliveryMainOption = $('input[name=\'optDeliveryMainOption\']:checked');
                    var objPickUpPoint = $('input[name=\'optPickUpPoint\']:checked');

                    // Save choice for delivery or pickup in session + pick up point
                    $.post(strAjaxPath + 'cart/save-delivery-main-option.php', 'intDeliveryMainOption=' + $(objDeliveryMainOption).val() + '&intPickUpPoint=' + (objPickUpPoint.length ? objPickUpPoint.val() : -1), function (arrObjecten) {
                        if (objDeliveryMainOption.val() == 1) {
                            // Pickup => show pick up points
                            $('#pick-up-points').removeClass('hidden');

                            // Update shipping costs (= free)
                            UpdateShippingCosts('intUseTransport=0');
                        } else {
                            // Home delivery => hide pick up points
                            $('#pick-up-points').addClass('hidden');

                            // Update shipping costs
                            UpdateShippingCosts('strCountryCode=' + $('select#selCountry').val());
                        }
                    });
                });
            }

            // Update shipping costs when changing the country (+ change deliverytypes if necessary)
            if ($('select#selCountry').closest('div').css('display') != 'none') {
                UpdateTransportOnCountryChange();
            }
        }
    });
});
